// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdf-box[data-v-39d52e62] {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  max-width: 13.65333rem;\n  width: 100%;\n  margin: 0 auto;\n  overflow-x: hidden;\n  height: 100%;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  font-size: .28rem;\n}\n.pdf-box span[data-v-39d52e62] {\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
